import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import flatpickr from 'flatpickr';
import {addDays, addYears} from 'date-fns';
//import {formatDate} from 'wc-lib';

@Component({
  template: require('./date-picker.html')
})
export class DatePicker extends Vue {
  @Prop({
    default: false
  })
  range: boolean | number;

  @Prop({
    default: 'day'
  })
  rangeType: string;

  @Prop()
  maxDate: Date;

  @Prop()
  gasDate: any;

  datepicker: any;
  

  mounted() {
    let defaultDate = this.gasDate ? this.gasDate : new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    if (this.gasDate.fromDate) {
      defaultDate = [];
      defaultDate.push(this.gasDate.fromDate);
      if (this.gasDate.toDate) {
        defaultDate.push(this.gasDate.toDate);
      }
    }

    this.datepicker = flatpickr(this.$refs.datePicker as HTMLElement, { 
      mode: this.range ? 'range' : 'single',
      defaultDate: defaultDate,
      wrap: true,
      maxDate: this.maxDate ? this.maxDate : null,
      minDate: new Date(2018, 8, 29),
      onChange: (selectedDates, dateStr, instance) => {

        if ((this.range === true || this.isInterger(this.range)) && selectedDates.length === 2) {
          this.$emit('input', {
            fromDate: selectedDates[0],
            toDate: selectedDates[1]
          }, 'yyyy-MM-dd');
          this.datepicker.set('enable', []);
        } else if  (this.range === false){
          this.$emit('input', selectedDates[0]);
        } else  if (this.isInterger(this.range) && selectedDates.length === 1) {
          this.datepicker.set('enable', [{
            from: this.rangeType === 'day' ? addDays(selectedDates[0], -this.range as number) : addYears(selectedDates[0], -this.range as number),
            to: this.rangeType === 'day' ?  addDays(selectedDates[0], this.range as number) : addYears(selectedDates[0], this.range as number)
          }]);

          this.datepicker.jumpToDate(selectedDates[0]);
        }
      },
      dateFormat: 'j M y'
    });
  }

  isInterger(value: any) {
    return typeof value === 'number' && 
      isFinite(value) && 
      Math.floor(value) === value;
  }
}



// WEBPACK FOOTER //
// src/components/date-picker.ts